import { useEffect, useState } from "react";
import QRScan from "../../components/qr_scan";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "../../hook/useQuery";
import Cookies from "js-cookie";

const PageHome = (props) => {
  const query = useQuery();

  const navigate = useNavigate();

  useEffect(() => {
    if (Cookies.get("token") === undefined) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <div
        className="w-full h-screen flex flex-col justify-center items-center bg-black px-5 bg-cover bg-no-repeat"
        style={{
          background: `url("${props?.setting?.background}")`,
        }}
      >
        <div className="flex flex-col justify-center items-center pb-20">
          <div className="text-white font-bold mb-10 text-xl uppercase">
            {query.get("event")}
          </div>
          <div className="mb-10 flex flex-col justify-center items-center space-y-2.5 w-full">
            <a
              href={`/home-1`}
              className={`min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-blue-500 w-full text-center`}
            >
              DAY 1
            </a>

            <a
              href={`/home-2`}
              className={`min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-blue-500 w-full text-center`}
            >
              DAY 2
            </a>

            {/* <a
              href={`/redeem?event=${query.get("event")}`}
              className={`min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-[#051f5b]  w-full text-center`}
            >
              REDEEM
            </a> */}

            {/* <a
              href={`/checkout?event=${query.get("event")}&id_gate=${query.get("id_gate")}`}
              className={`min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-[#051f5b]  w-full text-center`}
            >
              CHECK OUT
            </a> */}

            {/* <a
              href="/event"
              className="min-w-[160px] mt-4 px-10 py-2 bg-red-500 rounded-lg text-white font-bold w-full text-center"
            >
              BACK
            </a> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PageHome;
